import { Icon, IconProps, Tooltip, TooltipProps } from '@mui/material';
import { FC } from 'react';

import { Attention2Icon } from '../assets/assets';

type AttentionTooltipIconProps = {
  title: TooltipProps['title'];
  severity?: 'warning' | 'error';
  size?: IconProps['fontSize'];
};

export const AttentionTooltipIcon: FC<AttentionTooltipIconProps> = ({
  title,
  severity = 'warning',
  size,
}) => {
  return (
    <Tooltip describeChild componentsProps={{ tooltip: { sx: { padding: 1.25 } } }} title={title}>
      <Icon
        sx={(theme) => ({
          color: theme.palette.background.paper,
          path: {
            color: severity === 'warning' ? theme.palette.common.orange : theme.palette.error.main,
          },
        })}
        fontSize={size}
      >
        <Attention2Icon />
      </Icon>
    </Tooltip>
  );
};
